import { Component, HostListener, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AppState } from "src/app/store/app.reducer";
import * as DeviceVctActions from 'src/app/store/device-vct/device-vct.actions';
import { StandardPageLayout, StandardNewValidator } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { FeatureVct, ModuleVct } from "src/app/model/device-vct/device-vct-implant";
import { debounceTime, Subscription } from "rxjs";

@Component({
	templateUrl: './edit-intercommunicating-vct.dialog.component.html',
})

export class EditIntercommunicatingVctDialogComponent implements OnInit {
	editDeviceForm: FormGroup;

	deviceFilters: FormGroup;
	filterSub: Subscription;

	module: ModuleVct;

	featureListShow: FeatureVct[];

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private dialogRef: DynamicDialogRef,
		public config: DynamicDialogConfig,
		private formBuilder: FormBuilder,
	) {
		if (config.data !== undefined && this.config.data.module !== undefined) {
			this.module = this.config.data.module;
		} else {
			this.module = undefined;
		}
		this.initSelectors();
	}

	initSelectors(): void {
	}

	ngOnInit(): void {
		this.deviceFilters = new FormGroup({
			'searchFilter': new FormControl(''),
		});
		this.featureListShow = [];
		if (this.module !== undefined) {
			this.buildForm();
		}
		this.onResize();

		this.filterSub = this.deviceFilters.controls['searchFilter'].valueChanges.pipe(
			debounceTime(500),
		).subscribe(() => {
			if (this.module !== undefined) {
				this.buildForm();
			}
		});
	}


	buildForm(): void {
		this.editDeviceForm = this.formBuilder.group(this.buildFormBuilder());
	}


	buildFormBuilder() {
		this.featureListShow = [];
		console.log(this.module.Features);
		const nameFilter = this.deviceFilters.controls['searchFilter'].value;
		console.log(nameFilter);
		const res = {};
		/*let name = this.module.Name;
		if (this.module.AliasName !== '') {
			name = this.module.AliasName;
		}
		res['name'] = [name, [Validators.required,]];*/
		if (this.module.Features !== undefined && this.module.Features.length > 0) {
			this.module.Features.forEach((fea) => {
				let name = fea.Name;
				if (fea.AliasName !== '') {
					name = fea.AliasName;
				}
				if (name.includes(nameFilter)) {
					res[fea.Id] = [name, [Validators.required]];
					this.featureListShow.push(fea);
				}

			});
		}
		return res;
	}

	get f(): any {
		return this.editDeviceForm.controls;
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.editDeviceForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.editDeviceForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	saveFea(fea: FeatureVct): void {
		const newName = this.f[fea.Id].value;
		if (fea.AliasName !== newName) {
			this.store.dispatch(DeviceVctActions.editVctFeatureName({ featureId: fea.Id, aliasName: newName }));
			this.f[fea.Id].markAsPristine();
		}
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	newShowErrors(type: EditIntercommunicatingVctDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: EditIntercommunicatingVctDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	tabletUnderLgWidth(): boolean {
		return StandardPageLayout.tabletUnderLgWidth(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
}